import React from "react";

export const DeleteVirtualInstance = () => {
  return (
    <React.Fragment>
      <p>Are you sure you want to delete the virtual instance?</p>
      <p className="note_sec">
        <strong>Note: </strong>All the data contained in the Virtual Instance
        will be purged and unavailable once the deletion is completed.
      </p>
    </React.Fragment>
  );
};

export const RebootVirtualInstance = () => {
  return <p>Are you sure you want to restart your virtual instance?</p>;
};

export const SwitchPowerVirtualInstance = () => {
  return (
    <React.Fragment>
      <p>Are you sure you want to forcefully power off the virtual instance?</p>
      <p className="note_sec">
        <strong>Note: </strong>You may lose all your unsaved data if you 'Force
        Power Off' your instance. Furthermore, your virtual instance may become
        unbootable. It is recommended to login to the VM and use the shutdown
        option in the OS.
      </p>
    </React.Fragment>
  );
};
